import { render } from "./RCFileUploadRia.vue?vue&type=template&id=50a27bf0&scoped=true"
import script from "./RCFileUploadRia.vue?vue&type=script&lang=js"
export * from "./RCFileUploadRia.vue?vue&type=script&lang=js"

import "./RCFileUploadRia.vue?vue&type=style&index=0&id=50a27bf0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a27bf0"]])

export default __exports__